import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { EstimateItemPricingModel } from '@app/+authenticated/+reports/shared/subscriptions/subscription.model';
import { TranslatePipe } from '@ngx-translate/core';
import { clsx } from 'clsx';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'sb-addon-card',
  templateUrl: './addon-card.component.html',
  imports: [TranslatePipe],
  host: {
    '[class]': 'hostClasses',
  },
})
export class AddonCardComponent {
  hostClasses = clsx(
    'my-lg flex items-center justify-between rounded-2xl border-2 border-solid border-default px-lg py-md',
  );

  title = input.required<string>();
  description = input.required<string>();
  imgSrc = input.required<string>();
  pricingModel = input<EstimateItemPricingModel>('flat_fee');
  caption = input<string>();
}
